import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { PaymentallocationApi } from '../../redux/portfolio/portfolio';
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
// import { setuserDetail } from '../../redux/auth/auth';
import { PaymentallocationApi } from '../../../redux/portfolio/portfolio';
import { setuserDetail } from '../../../redux/auth/auth';
import { AddAllocationFund, AddFund, CheckAllocation } from '../../../api/portfolio';

const numberToWords = (num) => {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
        'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const convert = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + convert(n % 100) : "");
        if (n < 100000) return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
        if (n < 10000000) return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + convert(n % 100000) : "");
        return convert(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + convert(n % 10000000) : "");
    };

    if (!num || isNaN(num)) return '';
    return convert(Number(num)) + " Only";
};

const Allocation = () => {
    const navigate = useNavigate();
    const userId = useSelector(state => state.auth.userDetail.id);
    const dispatch = useDispatch();
    const userDetail = useSelector(state => state.auth.userDetail)
    const [amounts, setAmounts] = useState({
        wealthInvestmentAmt: "",
        multibaggerAllocation: "",
        etfAllocation: "",
    });

    const [validationErrors, setValidationErrors] = useState({});

    const handleAmountChange = (key) => (e) => {
        const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Only digits
        const formattedValue = new Intl.NumberFormat("en-IN").format(Number(rawValue));

        setAmounts((prev) => ({
            ...prev,
            [key]: formattedValue,
        }));

        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "",
        }));
    };

    const validation = () => {
        let errors = {};
        const multibagger = Number(amounts.multibaggerAllocation.replace(/,/g, ''));
        const wealth = Number(amounts.wealthInvestmentAmt.replace(/,/g, ''));
        const etf = Number(amounts.etfAllocation.replace(/,/g, ''));
        if (!multibagger || multibagger === 0) {
            errors.multibaggerAllocation = "Enter a valid amount";
        }
        if (!wealth || wealth === 0) {
            errors.wealthInvestmentAmt = "Enter a valid amount";
        }
        if (!etf || etf === 0) {
            errors.etfAllocation = "Enter a valid amount";
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handlePortfolio = async () => {
        if (!validation()) return;
        try {
            const payload = {
                multibaggerAllocation: Number(amounts.multibaggerAllocation.replace(/,/g, '')),
                wealthInvestmentAmt: Number(amounts.wealthInvestmentAmt.replace(/,/g, '')),
                // userId: userId
            };

            const etfPayload = {
                userId: userId,
                invPortId: 2,
                amt: Number(amounts.etfAllocation.replace(/,/g, '')),
            }

            const etfResponse = await AddFund(etfPayload);
            const response = await dispatch(PaymentallocationApi(payload));
            if (PaymentallocationApi.fulfilled.match(response)) {
                if (etfResponse?.status) {
                    const checkAllocation = await CheckAllocation(etfResponse?.data?.id)
                    if (checkAllocation?.status) {
                        let allocationPayload = {
                            userId: localStorage.getItem("uid"),
                            stocks: [],
                        };

                        checkAllocation?.data?.stocks?.map((item, idx) => {
                            allocationPayload.stocks.push({
                                invPortStockId: item.id,
                                entryPrice: item.cmp,
                                qty: item.qty
                            })
                        })
                        const allocatedFundResponse = await AddAllocationFund(allocationPayload, etfResponse?.data?.id);
                        if (allocatedFundResponse?.status) {
                            toast.success(response?.payload?.message);
                            dispatch(setuserDetail({ ...payload, etfAllocation: etfPayload.amt }))
                            navigate("/portfolio");
                        }
                    }
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    };
    return (
        <div className="py-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="border p-3 p-md-5 rounded-3 shadow-sm bg-secondary bg-opacity-10">
                            <h1 className="fs-4">Hi, {userDetail?.firstName ?? ''} {userDetail?.lastName ?? ''}</h1>
                            <p className="fst-italic ">
                                Welcome to WealthX, Let's create your initial portfolio
                            </p>
                            <hr />

                            {/* 🛍️ Initial Investment */}
                            <p className="mb-0 mt-4 fs-4">🛍️</p>
                            <p className="mb-2">
                                <i>Please enter your initial investment amount</i>{" "}
                                <i className="fa fa-info-circle text-secondary" />
                            </p>
                            <input
                                type="text"
                                className="w-75 form-control form-control-lg"
                                placeholder="Enter amount in ₹"
                                value={amounts.wealthInvestmentAmt}
                                onChange={handleAmountChange("wealthInvestmentAmt")}
                            />
                            {validationErrors.wealthInvestmentAmt && (
                                <div className="text-danger mt-1">
                                    {validationErrors.wealthInvestmentAmt}
                                </div>
                            )}
                            <small className="fst-italic text-success d-block">
                                {numberToWords(amounts.wealthInvestmentAmt.replace(/,/g, ''))}
                            </small>

                            {/* 🚀 Multibagger Investment */}
                            <p className="mb-0 mt-4 fs-4">🚀</p>
                            <p className="mb-2">
                                <i>Please enter investment amount per multibagger stocks</i>{" "}
                                <i className="fa fa-info-circle text-secondary" />
                            </p>
                            <input
                                type="text"
                                className="w-75 form-control form-control-lg"
                                placeholder="Enter amount in ₹"
                                value={amounts.multibaggerAllocation}
                                onChange={handleAmountChange("multibaggerAllocation")}
                            />
                            {validationErrors.multibaggerAllocation && (
                                <div className="text-danger mt-1">
                                    {validationErrors.multibaggerAllocation}
                                </div>
                            )}
                            <small className="fst-italic text-success d-block">
                                {numberToWords(amounts.multibaggerAllocation.replace(/,/g, ''))}
                            </small>

                            {/* 🚀 ETF Investment */}
                            <p className="mb-0 mt-4 fs-4">🚀</p>
                            <p className="mb-2">
                                <i>Please enter your initial investment amount for ETfs</i>{" "}
                                <i className="fa fa-info-circle text-secondary" />
                            </p>
                            <input
                                type="text"
                                className="w-75 form-control form-control-lg"
                                placeholder="Enter amount in ₹"
                                value={amounts.etfAllocation}
                                onChange={handleAmountChange("etfAllocation")}
                            />
                            {validationErrors.etfAllocation && (
                                <div className="text-danger mt-1">
                                    {validationErrors.etfAllocation}
                                </div>
                            )}
                            <small className="fst-italic text-success d-block">
                                {numberToWords(amounts.etfAllocation.replace(/,/g, ''))}
                            </small>

                            {/* Submit Button */}
                            <button
                                className="btn mt-4"
                                style={{
                                    // height: '45px', 
                                    background: 'linear-gradient(to right, #C609FA, #3959FE, #0E9EEE)',
                                    color: 'white', // or another readable solid color
                                    // height: '45px',
                                    border: 'none',
                                }}
                                onClick={handlePortfolio}
                            >
                                Create My Portfolio
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Allocation;
